import { sensorService } from '../_services';
import { router } from '../_helpers';
const state = { onRequest: false, sensors: [], sensor: {} };

const actions = {
    get({ dispatch, commit }, id) {
        commit('request');

        sensorService.get(id)
            .then(
                resp => {
                    commit('success_data', resp);
                },
                error => {
                    commit('error');
                    dispatch('alert/error', error, { root: true });
                }
            );
    },
    add({ dispatch, commit }, data) {
        commit('request');

        sensorService.add(data)
            .then(
                async () => {
                    commit('success');
                    await router.push('/sensors');
                    dispatch('alert/success', "Sensor Added Successfully", { root: true });
                },
                async error => {
                    commit('error');
                    await router.push('/sensors');
                    dispatch('alert/error', error, { root: true });
                }
            );
    },
    edit({ dispatch, commit }, data) {
        commit('request');

        sensorService.edit(data)
            .then(
                async () => {
                    commit('success');
                    await router.push('/sensors');
                    dispatch('alert/success', "Sensor Updated Successfully", { root: true });
                },
                async error => {
                    commit('error');
                    await router.push('/sensors');
                    dispatch('alert/error', error, { root: true });
                }
            );
    },
    get_all({ dispatch, commit }) {
        commit('request');

        sensorService.get_all()
            .then(
                (resp) => {
                    commit('success_datas', resp);
                },
                error => {
                    commit('error');
                    dispatch('alert/error', error, { root: true });
                }
            );
    },
    destroy({ dispatch, commit }, id){
      commit('request');

      sensorService.destroy(id)
          .then(
              async () => {
                  commit('success');
                  await router.go('/sensors');
                  dispatch('alert/success', "Sensor Deleted Successfully", { root: true });
              },
              async error => {
                  commit('error');
                  await router.go('/sensors');
                  dispatch('alert/error', error, { root: true });
              }
          );
    },
};
const getters = {
  onRequest: state => {
    return state.onRequest
  },
  sensors: state => {
    return state.sensors
  },
  sensor: state => {
    return state.sensor
  },
};

const mutations = {
    request(state) {
        state.onRequest = true;
        state.sensors = [];
    },
    success(state) {
      state.onRequest = false;
    },
    success_data(state, data) {
      state.onRequest = false;
      state.sensor = data;
    },
    success_datas(state, data) {
      state.onRequest = false;
      state.sensors = data;
    },
    error(state) {
        state.onRequest = false;
    },
};

export const sensors = {
    namespaced: true,
    state,
    actions,
    getters,
    mutations
};
